import { createSlice, createAsyncThunk, createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { saveTreatmentActivityList as saveActivityList, resetActivityPpromise } from "@amplio-common/treatments/api";
import { simpleSetPayload, PREVIEW_BOARD_ID } from "../constants";
import { sortByFieldAlphabetically } from "@amplio-common/funcs/commonFunctionalities";
// import { getPinnedBoard, getPreviewBoardMode, selectIsPreview } from "./contentSlice";
import { VIDEO_SESSION_PAGES as VSP } from "@app/common/data/ActivitiessEnums";
import { getPinnedBoard, getPreviewBoardMode, selectIsPreview } from "./contentSlice";

import { SLICE_NAMES } from "./sliceNames";

export const saveTreatmentActivityList = createAsyncThunk(
  `${SLICE_NAMES.STUDIO_SLICE}/saveActivityList`, async(params) => {
    const { pl, treatmentId } = params;
    saveActivityList(pl, treatmentId);
  },
);

//define root selector

const studioSlice_STATE_ROOT_SELECTOR = state => state[SLICE_NAMES.STUDIO_SLICE];

const createSimpleSelector = (fieldName) => createSelector(
  [state => state[SLICE_NAMES.STUDIO_SLICE][fieldName]], field => field,
);


const sortFunc = sortByFieldAlphabetically("name");

export const studioStudentsAdapter = createEntityAdapter({
  sortComparer: sortFunc,
});


export const studioMapTSToStudentStatus = (ts) => ({
  id: ts.student.id,
  name: ts.student.name,
  selectedActivity: null,
  loadedActivity: null,
  types: null,
});

const studioStudentsAdapterSelectors = studioStudentsAdapter.getSelectors(studioSlice_STATE_ROOT_SELECTOR);

const initialState = {
  studioActivityPlaylist: [],
  previewSelectedActivity: null, // when selected
  previewLoadedActivity: null, // when loaded
  isManualShowPlaylist: false,
  ...studioStudentsAdapter.getInitialState(),
};


export const studioSlice = createSlice({
  name: SLICE_NAMES.STUDIO_SLICE,
  initialState,
  reducers: {
    cleareStudio: () => ({ ...initialState }),
    setStudioActivityPlaylist: simpleSetPayload("studioActivityPlaylist"),
    setIsManualShowPlaylist: simpleSetPayload("isManualShowPlaylist"),
    setPreviewSelectedActivity: simpleSetPayload("previewSelectedActivity"),
    setPreviewLoadedActivity: simpleSetPayload("previewLoadedActivity"),
    studioUpdateStudentStatus: studioStudentsAdapter.updateOne,
    studioSetStudentsStatus: studioStudentsAdapter.setAll,
    studioUpdateAllStudents: studioStudentsAdapter.updateMany,
  },
  extraReducers: {

  },
});

export default studioSlice.reducer;

//actions

export const { studioUpdateStudentStatus, studioSetStudentsStatus, studioUpdateAllStudents, cleareStudio, setIsManualShowPlaylist,
  setStudioActivityPlaylist, setPreviewSelectedActivity, setPreviewLoadedActivity } = studioSlice.actions;

//selectors

export const selectPreviewLoadedActivity = createSimpleSelector("previewLoadedActivity");
export const selectIsManualShowPlaylist = createSimpleSelector("isManualShowPlaylist");

const getStudioActivityPlaylist = (state) => state[SLICE_NAMES.STUDIO_SLICE].studioActivityPlaylist;
const getIsManualShowPlaylist = (state) => state[SLICE_NAMES.STUDIO_SLICE].isManualShowPlaylist;
const getPreviewSelectedActivity = (state) => state[SLICE_NAMES.STUDIO_SLICE].previewSelectedActivity;

export const selectPreviewSelectedActivity = createSelector(
  [getPreviewSelectedActivity], previewSelectedActivity => previewSelectedActivity,
);

export const selectIsShowStudioActivityPlaylist = createSelector(
  [getIsManualShowPlaylist, getPreviewSelectedActivity, getPreviewBoardMode, selectIsPreview],
  (isManualPlaylist, previewSelectedActivity, previewBoardMode, isPreview) =>
    isPreview && previewBoardMode === VSP.ACTIVITY && (isManualPlaylist || !previewSelectedActivity),
);

export const {
  selectAll: studioSelectAllStudentsStatus, selectIds: studioSelectStudentStatusIds, selectById: studioSelectStudentStatusById,
} = studioStudentsAdapterSelectors;

export const selectStudioActivityPlaylist = createSelector([getStudioActivityPlaylist], pl => (pl || []).map(o => o = { ...o }));

export const selectSelectedActivity = createSelector([getPreviewSelectedActivity, getPinnedBoard, studioStudentsAdapterSelectors.selectEntities],
  (previewSelectedActivity, pinnedBoard, studentStatus) => pinnedBoard === PREVIEW_BOARD_ID ? previewSelectedActivity : studentStatus[pinnedBoard].selectedActivity);

export const selectLoadedActivity = createSelector(
  [selectPreviewLoadedActivity, getPinnedBoard, studioStudentsAdapterSelectors.selectEntities],
  (previewLoadedActivity, pinnedBoard, studentStatus) => pinnedBoard === PREVIEW_BOARD_ID ? previewLoadedActivity : studentStatus[pinnedBoard].loadedActivity,
);

export const resetActivity = createAsyncThunk(
  `${SLICE_NAMES.STUDIO_SLICE}/resetActivity`,
  async ({ student_id, activity }, thunkAPI) => {
    if (!student_id || !activity) { return; }

    thunkAPI.dispatch(studioUpdateStudentStatus({ id: student_id, changes: { selectedActivity: {} } }));
    await resetActivityPpromise(student_id, activity?.id);
    
    thunkAPI.dispatch(studioUpdateStudentStatus({ id: student_id, changes: { selectedActivity: activity } }));
  },
);
